import { graphql } from 'react-apollo'
import BulkCustomization       from '/models/bulk-customization'

#
# Queries
#
import index    from './queries/index.gql'

export withBulkCustomizations = graphql index,
  options: (props)->
    { page, search, filters } = props.location.state or {}
    variables:
      page: page or 1
      filters: filters or {}
  props: ({props, data})->
    { nodes, pagination } = data.bulk_customizations or {}
    bulk_customizations: BulkCustomization.parse nodes or []
    bulk_customizationsPagination: pagination
    bulk_customizationsLoading: data.loading
    bulk_customizationsRefetch: data.refetch

#
# Mutations
#
import rpc          from '/mutations/bulk_customizations/rpc.gql'

export withRPC = graphql rpc,
  props: ({ mutate })->
    rpc: (id, method)->
      {data: {bulk_customization_rpc: {bulk_customization, errors}}} = \
      await mutate variables: {id, method}
      {bulk_customization, errors}
